const IMA_SDK_URL = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';

let loadPromise: Promise<void> | null = null;

export function loadImaSdk(): Promise<void> {
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.google?.ima?.AdsRequest) return Promise.resolve();
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = IMA_SDK_URL;
    script.onload = () => resolve();
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load Google IMA SDK'));
    };
    document.body.appendChild(script);
  });

  return loadPromise;
}
